// src/pages/grow-business.tsx
import React from 'react';
import { Helmet } from 'react-helmet';
import { GrowthScheduler } from '@/components/scheduler';
import '@/components/scheduler/scheduler.css';

const GrowBusinessPage: React.FC = () => {
    const handleSchedulingComplete = (appointmentId: string) => {
        // Track conversion in analytics
        if (window.gtag) {
            window.gtag('event', 'appointment_scheduled', {
                event_category: 'engagement',
                event_label: appointmentId
            });
        }
    };

    return (
        <>
            <Helmet>
                <title>Grow Your Business | Swift Lead Digital</title>
                <meta
                    name="description"
                    content="Schedule a free discovery call to learn how Swift Lead Digital can help grow your business with data-driven strategies."
                />
            </Helmet>

            <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    {/* Scheduler Component */}
                    <GrowthScheduler
                        apiBaseUrl={import.meta.env.VITE_API_URL || 'http://localhost:8080'}
                        onComplete={handleSchedulingComplete}
                    />
                </div>
            </div>
        </>
    );
};

export default GrowBusinessPage;